import tnDateSelectTemplate from './tn-date-select.html';
const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
function getMonthName(idx: number | undefined) {
    if (idx === undefined) {
        return 'Clear';
    }
    return monthNames[idx - 1];
}
function getYearDisplay(year) {
    if (year === undefined) {
        return 'Clear';
    }
    return year;
}

const years: number[] = [];
(function () {
    const year = new Date().getFullYear();
    for (let i = 2015; i <= year; ++i) {
        years.push(i);
    }
})();

export function tnDateSelect() {
    return {
        restrict: 'E', // update only elements
        scope: {
            tnMonthModel: '=',
            tnYearModel: '=',
            tnLabelName: '@',
        },
        link: function ($scope, elem, attr) {
            const currentDate = ($scope.currentDate = new Date());
            $scope.selectMonth = (month) => {
                if ($scope.tnMonthModel === month) {
                    $scope.tnMonthModel = undefined;
                } else {
                    $scope.tnMonthModel = month;
                }
            };
            $scope.selectYear = (year) => {
                if ($scope.tnYearModel === year) {
                    $scope.tnYearModel = undefined;
                } else {
                    $scope.tnYearModel = year;
                }
            };

            $scope.years = years;
            $scope.monthNames = monthNames;
            $scope.getMonthName = getMonthName;
            $scope.getYearDisplay = getYearDisplay;
            $scope.monthPlaceholder = parseInt(
                attr.tnMonthPlaceholder || currentDate.getMonth() + 1
            );
            $scope.yearPlaceholder = parseInt(
                attr.tnYearPlaceholder || currentDate.getFullYear()
            );
        },
        template: tnDateSelectTemplate,
    };
}
